import React from 'react';
import FrontInfoBox from "./FrontInfoBox/FrontInfoBox";
import classes from "./FrontInfoBoxes.module.css";

const FrontInfoBoxes = () => (
    <div className={classes.FrontInfoBoxes}>
        <FrontInfoBox>Ala ma kota</FrontInfoBox>
        <FrontInfoBox>Ala ma psa</FrontInfoBox>
        <FrontInfoBox>Ala ma wieworkę</FrontInfoBox>
    </div>
);

export default FrontInfoBoxes;
